import { Pipe, PipeTransform } from '@angular/core';
import { LOCALE_ID, Inject } from '@angular/core';
import { getLocaleCurrencySymbol } from '@angular/common';

@Pipe({
  name: 'moedaLocal'
})
export class MoedaLocalPipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) public locale: string) {
  }

  transform(value: number): any {
    let str = getLocaleCurrencySymbol(this.locale) + new
      Intl.NumberFormat(this.locale, {
        style: 'decimal', minimumFractionDigits: 2
      }).format(value);
    // str = "R" + str;
    // Replace `,` by some unique string
    str = str.replace(/,/g, "__COMMA__")
      // Replace `.` by `,`
      .replace(/\./g, ',')
      .replace(/__COMMA__/g, '.');;
    return str;
  }
}
